import { render } from "./Retirement.vue?vue&type=template&id=23a9c5ce"
import script from "./Retirement.vue?vue&type=script&lang=js"
export * from "./Retirement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__